module.exports = __webpack_public_path__ + "img/windows.9285ab3c.png";